import { render, staticRenderFns } from "./DZCapital.vue?vue&type=template&id=308ed09c&scoped=true&"
import script from "./DZCapital.vue?vue&type=script&lang=js&"
export * from "./DZCapital.vue?vue&type=script&lang=js&"
import style0 from "./DZCapital.vue?vue&type=style&index=0&id=308ed09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ed09c",
  null
  
)

export default component.exports